import React, { useLayoutEffect } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";

type Props = {
  data: any;
  chartId?: string;
};

const StackedBarChart = ({ data, chartId }: Props) => {
  useLayoutEffect(() => {
    let root: any;

    if (chartId) {
      root = am5.Root.new(chartId);
    } else {
      root = am5.Root.new("stackbarchartdiv");
    }

    /* remove amchart logo */
    root._logo?.dispose();

    let chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: false,
        panY: false,
        // wheelX: "panY",
        // wheelY: "zoomY",
        layout: root.verticalLayout,
      })
    );

    chart.children.unshift(
      am5.Label.new(root, {
        text: "Overall Win-Loss FY-YTD",
        fontWeight: "600",
        textAlign: "center",
        x: am5.percent(50),
        centerX: am5.percent(100),
      })
    );
    // chart.set(
    //   "scrollbarY",
    //   am5.Scrollbar.new(root, {
    //     orientation: "vertical",
    //   })
    // );

    let yRenderer = am5xy.AxisRendererY.new(root, {});
    let yAxis = chart.yAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "category",
        renderer: yRenderer,
        tooltip: am5.Tooltip.new(root, {}),
      })
    );

    yRenderer.grid.template.setAll({
      location: 1,
    });

    yAxis.data.setAll(data);

    yAxis.labelsContainer.set(
      "tooltip",
      am5.Tooltip.new(root, {
        pointerOrientation: "up",
      })
    );
    yAxis.get("renderer").labels.template.setAll({
      oversizedBehavior: "truncate",
      maxWidth: 60,
      textAlign: "center",
      tooltipText: "{category}",
    });

    yRenderer.labels.template.setup = function (target: any) {
      target.set(
        "background",
        am5.Rectangle.new(root, {
          fill: am5.color(0x000000),
          fillOpacity: 0,
        })
      );
    };

    let xAxis = chart.xAxes.push(
      am5xy.ValueAxis.new(root, {
        min: 0,
        renderer: am5xy.AxisRendererX.new(root, {
          strokeOpacity: 0.1,
        }),
      })
    );

    xAxis.get("renderer").labels.template.setAll({
      oversizedBehavior: "hide",
      maxWidth: 5,
      // textAlign: "center",
      // tooltipText: "{category}",
    });
    // xAxis.get("rendered").labels.template

    // var xLabels1 = chart.xAxes.labels();
    // xLabels1.format(function (val: number) {
    //   var value = val;
    //   // scale USD to EUR
    //   value = Math.round(value / 1000);

    //   return value + "K";
    // });

    // Add legend
    // let legend = chart.children.push(
    //   am5.Legend.new(root, {
    //     centerX: am5.p50,
    //     x: am5.p50,
    //   })
    // );

    function makeSeries(name: any, fieldName: any) {
      let series = chart.series.push(
        am5xy.ColumnSeries.new(root, {
          name: name,
          stacked: true,
          xAxis: xAxis,
          yAxis: yAxis,
          baseAxis: yAxis,
          valueXField: fieldName,
          categoryYField: "category",
        })
      );

      series.columns.template.setAll({
        tooltipText: `{name}, #: {${fieldName}Count}, INR {valueX} Cr`,
        tooltipY: am5.percent(90),
        height: am5.percent(40),
      });

      series.data.setAll(data);

      // Make stuff animate on load
      series.appear();

      series.bullets.push(function () {
        return am5.Bullet.new(root, {
          sprite: am5.Label.new(root, {
            // text: "{valueX}",
            fill: root.interfaceColors.get("alternativeText"),
            centerY: am5.p50,
            centerX: am5.p50,
            populateText: true,
          }),
        });
      });

      // legend.data.push(series);
    }

    // Make stuff animate on load

    makeSeries("Won", "Won");
    makeSeries("Lost", "Lost");

    chart.appear(1000, 100);

    return () => {
      // Clean up any resources or event listeners here
      root.dispose();
    };
  });

  return (
    <div
      id={chartId ? chartId : "stackbarchartdiv"}
      style={{ width: "100%", height: "100%" }}
    ></div>
  );
};

export default StackedBarChart;
